import React from 'react';

/**
 * TimeSlipOverlayコンポーネントのプロパティ
 */
export interface TimeSlipOverlayProps {
  /** 表示するかどうか */
  visible: boolean;
  /** 過去方向への移動かどうか（省略時は過去方向と判断） */
  isPast?: boolean;
}

/**
 * タイムスリップオーバーレイコンポーネント
 *
 * history-sliderでルームの履歴を切り替えたときに表示される、
 * 時計の針が回るアニメーション
 * 過去方向への移動時は反時計回り、未来方向への移動時は時計回り
 */
export function TimeSlipOverlay({ visible, isPast = true }: TimeSlipOverlayProps) {
  if (!visible) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        color: 'white',
        fontSize: '16px',
        zIndex: 999, // LoadingOverlayより下に表示
        pointerEvents: 'none' // マウス操作を下のレイヤーに通す
      }}
    >
      <div
        style={{
          width: '280px',
          height: '130px',
          borderRadius: '8px',
          backgroundColor: 'rgba(56, 54, 53, 0.7)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '16px'
        }}
      >
        <div style={{ position: 'relative', width: '40px', height: '40px' }}>
          {/* 時計の文字盤 */}
          <div
            style={{
              position: 'absolute',
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              border: '3px solid white',
              boxSizing: 'border-box'
            }}
          />

          {/* 短針 - SVGで描画 */}
          <div
            style={{
              position: 'absolute',
              width: '40px',
              height: '40px',
              top: 0,
              left: 0,
              animation: isPast
                ? 'rotateCounterClockwiseHour 12s linear infinite'
                : 'rotateClockwiseHour 12s linear infinite',
              transform: 'translate(0.5px, 0.5px)' // ピクセル整合性を向上させるための半ピクセル移動
            }}
          >
            <svg height='40' viewBox='0 0 40 40' width='40'>
              <line stroke='white' strokeLinecap='round' strokeWidth='3' x1='20' x2='20' y1='20' y2='11' />
            </svg>
          </div>

          {/* 長針 - SVGで描画 */}
          <div
            style={{
              position: 'absolute',
              width: '40px',
              height: '40px',
              top: 0,
              left: 0,
              animation: isPast
                ? 'rotateCounterClockwiseMinute 1s linear infinite'
                : 'rotateClockwiseMinute 1s linear infinite',
              transform: 'translate(0.5px, 0.5px)' // ピクセル整合性を向上させるための半ピクセル移動
            }}
          >
            <svg height='40' viewBox='0 0 40 40' width='40'>
              <line stroke='white' strokeLinecap='round' strokeWidth='3' x1='20' x2='20' y1='20' y2='8' />
            </svg>
          </div>
        </div>
        <div style={{ fontFamily: 'Meiryo, sans-serif' }}>{isPast ? '空間履歴切り替え中…' : '空間履歴切り替え中…'}</div>
      </div>
      <style>
        {`
          @keyframes rotateClockwiseHour {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          
          @keyframes rotateCounterClockwiseHour {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(-360deg); }
          }
          
          @keyframes rotateClockwiseMinute {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          
          @keyframes rotateCounterClockwiseMinute {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(-360deg); }
          }
        `}
      </style>
    </div>
  );
}
